import { Component, OnInit, AfterViewInit, ViewChild, Renderer, ElementRef, OnDestroy } from "@angular/core";
import { AlertController, App, LoadingController, NavParams, Slides } from "ionic-angular";
import { BauCuaService } from "../../services/baucua.service";
import { AppDialog } from "../../component/appDialog";
import { LotteryPage } from "../lottery/lottery";
import { BauCuaHistoryPage } from "../baucuaHistory/baucuaHistory";
import { CommonService } from "../../services/common.service";
import { LoginPage } from "../login/login";
import { TranslateService } from "ng2-translate";

@Component({
    selector: "bau-cua-1giay-page",
    templateUrl: "baucua1giaypage.html"
})
export class BauCua1GiayPage implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(Slides) slides: Slides;
    private objChips = [
        { chipTitle: "5", chipVal: "5", status: 1 },
        { chipTitle: "10", chipVal: "10", status: 0 },
        { chipTitle: "24", chipVal: "25", status: 0 },
        { chipTitle: "50", chipVal: "50", status: 0 },
        { chipTitle: "100", chipVal: "100", status: 0 },
        { chipTitle: "200", chipVal: "200", status: 0 },
        { chipTitle: "300", chipVal: "300", status: 0 },
        { chipTitle: "400", chipVal: "400", status: 0 },
        { chipTitle: "500", chipVal: "500", status: 0 }
    ];
    private numChipsShow: number = 4;
    private statusOpenWin = {
        0: this.translate.instant('CHUA_MO_THUONG'),
        1: this.translate.instant('DANG_CHO_MO_THUONG'),
        2: this.translate.instant('DANG_CHO_TINH_THUONG'),
        3: this.translate.instant('TRUOT'),
        4: this.translate.instant('TRUNG'),
        5: this.translate.instant('HUY_NUOI_CUOC'),
        6: this.translate.instant('CA_NHAN_HUY_CUOC'),
        7: this.translate.instant('HUY_MO_THUONG')
    };
    private modelGame: any = [];
    private objAudioPlay = new Audio('build/assets/images/baucua/audio/xocdia.wav');
    private objAudioOpen = new Audio('build/assets/images/baucua/audio/xocdiaopen.mp3');
    private renderDices: any = [];
    public pageDome: HTMLElement;
    private maxGroupChip: number = 5;
    private objCallBackChipSlide: any = {};
    private storeDataBetting: any = [];
    private gameID: number;
    private storeBalance: string = '';
    private dataTypeBet = new DATA_ITEM_BETTING();
    private storeDataReBet: any = [];
    private isMuted: boolean = true;
    public totalMoneyShow: number = 0;
    public selectedLanguage: string = 'vi';


    constructor(private app: App, private cs: CommonService, public params: NavParams, private bcService: BauCuaService, private el: ElementRef, private alertCtrl: AlertController, public loadingCtrl: LoadingController, private common: CommonService, private translate: TranslateService) {
        const getDataParams = params['data'];
        this.gameID = LotteryPage.lotteryId = Number(getDataParams['lotteryId']);

        const storedLanguage = localStorage.getItem('langcode');
        if (storedLanguage) {
            this.selectedLanguage = storedLanguage;
        } else {
            this.selectedLanguage = 'vi'; // Mặc định là tiếng Anh nếu không có giá trị trong localStorage
        }

        // Thêm lớp động vào phần tử gốc
        document.documentElement.setAttribute('lang', this.selectedLanguage);

        // vnd
        if (LoginPage.cytype != 1) {
            // vndK
            this.objChips = [
                { chipTitle: "5", chipVal: "5", status: 1 },
                { chipTitle: "10", chipVal: "10", status: 0 },
                { chipTitle: "25", chipVal: "25", status: 0 },
                { chipTitle: "50", chipVal: "50", status: 0 },
                { chipTitle: "100", chipVal: "100", status: 0 },
                { chipTitle: "200", chipVal: "200", status: 0 },
                { chipTitle: "300", chipVal: "300", status: 0 },
                { chipTitle: "400", chipVal: "400", status: 0 },
                { chipTitle: "500", chipVal: "500", status: 0 }
            ];
        } else {
            // vnd
            this.objChips = [
                { chipTitle: "5k", chipVal: "5000", status: 1 },
                { chipTitle: "10k", chipVal: "10000", status: 0 },
                { chipTitle: "25k", chipVal: "25000", status: 0 },
                { chipTitle: "50k", chipVal: "50000", status: 0 },
                { chipTitle: "100k", chipVal: "100000", status: 0 },
                { chipTitle: "200k", chipVal: "200000", status: 0 },
                { chipTitle: "300k", chipVal: "300000", status: 0 },
                { chipTitle: "400k", chipVal: "400000", status: 0 },
                { chipTitle: "500k", chipVal: "500000", status: 0 }
            ];

        }
        this.pageDome = el.nativeElement;
    }

    mapModel(model) {
        this.modelGame = model.map(itemModel => {
            let order = 0;
            if (itemModel['checkflag'] === 'nai') { order = 1; }
            else if (itemModel['checkflag'] === 'cua') { order = 2; }
            else if (itemModel['checkflag'] === 'ga') { order = 3; }
            else if (itemModel['checkflag'] === 'ca') { order = 4; }
            else if (itemModel['checkflag'] === 'bau') { order = 5; }
            else if (itemModel['checkflag'] === 'tom') { order = 6; }
            return {
                order: order,
                typebet: itemModel['checkflag'],
                maxbet: itemModel['maxbet'],
                levelnum: itemModel['levelnum'],
                ratio: Math.abs(Number(itemModel['level1']) - Number(itemModel['levelnum']))
            }
        });
        this.modelGame.sort((a, b) => {
            return a.order - b.order;
        });
        this.randerPositionDice();
    }

    apiInitBauCua() {
        this.totalMoneyShow = 0;
        this.bcService.initBC1s([], this).then(data => {
            if (data['msg'] === '') {
                this.mapModel(data['model']);
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data['msg']
                });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    apiGetBalance() {
        this.bcService.getBalanceMain([], null).then(data => {
            if (data['msg'] === '') {
                this.storeBalance = this.common.numberWithCommas(data['balance']);
            } else {
                this.storeBalance = "0";
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data['msg']
                });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    randerPositionDice(valPosi?: string) {
        const posiItem = valPosi ? this.randomPosiOverlapping(valPosi) : this.randomPosiOverlapping();
        let str = '';
        posiItem.itemRandom.forEach((item, idx) => {
            const getNameDice = this.modelGame.find(model => model['order'] === Number(item));
            str += `<span style="top:${posiItem.posiRandom[idx].y}px;left:${posiItem.posiRandom[idx].x}px" class="iconBauCua dice-${getNameDice['typebet']}"></span>`;
        });
        const elWrapDice = this.pageDome.querySelector('#items-dice');
        elWrapDice.innerHTML = str;
    }

    randomPosiOverlapping(valPosi?: string) {
        let arrValColor = [];
        const posiItem = [
            [{ "y": "28", "x": "85" }, { "y": "42", "x": "136" }, { "y": "40", "x": "45" }],
            [{ "y": "59", "x": "85" }, { "y": "42", "x": "120" }, { "y": "24", "x": "61" }],
            [{ "y": "52", "x": "55" }, { "y": "28", "x": "120" }, { "y": "24", "x": "84" }],
            [{ "y": "53", "x": "85" }, { "y": "42", "x": "45" }, { "y": "24", "x": "126" }],
            [{ "y": "23", "x": "85" }, { "y": "42", "x": "45" }, { "y": "50", "x": "126" }],
            [{ "y": "56", "x": "93" }, { "y": "42", "x": "139" }, { "y": "31", "x": "67" }],
            [{ "y": "56", "x": "81" }, { "y": "30", "x": "110" }, { "y": "27", "x": "56" }]
        ];

        if (valPosi) {
            arrValColor = valPosi.split('|');
        } else {
            for (let i = 0; i < 3; i++) {
                arrValColor.push(this.getRandomInt(1, 6));
            }
        }

        const objRandom = posiItem[this.getRandomInt(0, posiItem.length - 1)];
        return { itemRandom: arrValColor, posiRandom: objRandom };
    }

    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    selectTypeBet(typeBet) {
        const chipVal = this.objChips.find(chip => chip.status === 1).chipVal;
        const chipTitle = this.objChips.find(chip => chip.status === 1).chipTitle;


        this.preventTimeoutAdd();
        let curChipActive = null;
        for (let i = 0; i < this.slides['_slides'].length; i++) {
            let item = this.slides['_slides'][i];
            if (item.querySelector('.chip.active')) {
                curChipActive = i;
                break;
            }
        }

        let countCurShowChip = this.slides.getActiveIndex() + 4;
        if (countCurShowChip <= curChipActive || countCurShowChip - curChipActive > 4) { // slide to up
            this.slides.slideTo(curChipActive);
            this.objCallBackChipSlide = { chipVal: chipVal, typeBet: typeBet, chipTitle: chipTitle };
        } else { // slide normal
            this.objCallBackChipSlide = {};
            this.addChip(chipVal, typeBet, chipTitle);
        }
    }

    slideTransitionEnd() {
        if (!this.isEmptyObject(this.objCallBackChipSlide)) {
            this.addChip(this.objCallBackChipSlide.chipVal, this.objCallBackChipSlide.typeBet, this.objCallBackChipSlide.chipTitle);
            this.objCallBackChipSlide = {};
        }
    }

    addChip(chipVal, typeBet, chipTitle) {
        // console.log('chipTitle', chipTitle);

        const checkTypeBetMaxBet = this.storeDataBetting.find(itemMaxBet => itemMaxBet['itemBetting'] === typeBet);
        const getTypeBetModel = this.modelGame.find(model => model['typebet'] === typeBet);
        if (checkTypeBetMaxBet && checkTypeBetMaxBet.totalMoney >= getTypeBetModel.maxbet) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: `Vượt mức giới hạn cược ${this.cs.numberWithCommas(getTypeBetModel.maxbet)}`
            });
            this.preventTimeoutRemove();
            return;
        }
        const elTypeBet = this.pageDome.querySelector(`[data-bet="${typeBet}"]`);
        const getPosiTypeBet = this.getPositionXYEl(elTypeBet);
        const elChipActive = this.pageDome.querySelector(`[data-chip="${chipVal}"]`);
        const chip = document.createElement('span');
        const getPosiCurrentChipActive = this.getPositionXYEl(elChipActive);
        let elChipEmbed = elTypeBet.querySelectorAll('.chipEmbed');
        let elChipLast = undefined;
        let zIndexChip = "1";
        if (elChipEmbed.length > 0) {
            elChipLast = elChipEmbed[elChipEmbed.length - 1];
            zIndexChip = (Number(elChipLast.style.zIndex) + 1).toString();
        }


        // const body = document.body;
        const body = document.getElementById("wrapper");

        // Get the bounding rectangle of the body
        const bodyRect = body.getBoundingClientRect();
        // console.log('====================================');
        // console.log('bodyRect', bodyRect);
        // console.log('====================================');
        // Calculate the left distance from the body to the full screen
        const leftDistance = bodyRect.left;
        chip.style.zIndex = zIndexChip;
        chip.classList.add('chip', 'chipEmbed');
        chip.style.top = getPosiCurrentChipActive.y + 'px';
        chip.style.left = getPosiCurrentChipActive.x - leftDistance + 'px';
        chip.setAttribute('data-chipval', chipVal);
        chip.innerHTML = `<span class="iconBauCua item chip-${chipVal}"><span class="light-around iconBauCua"></span></span><span class="numchip">${chipTitle}</span>`;
        elTypeBet.appendChild(chip);

        // start move effect chip
        setTimeout(() => {
            let topChipMove = getPosiTypeBet.y + getPosiTypeBet.h - getPosiCurrentChipActive.h - 10;
            let leftChipMove = getPosiTypeBet.x + getPosiTypeBet.w / 2 - getPosiCurrentChipActive.w / 2;
            chip.style.left = leftChipMove - leftDistance + 'px';
            let elsChipEmbed = elTypeBet.querySelectorAll('.chipEmbed');
            if (elsChipEmbed.length > this.maxGroupChip) { // group chip and calculate position top for chip next hidden
                topChipMove = elChipLast.style.top.replace('px', '');
                chip.classList.add('chipEmbedHideGroup');
                this.updateMoneyGroupChips(typeBet);
            } else if (elChipLast) { // position top for chip next
                topChipMove = Number(elChipLast.style.top.replace('px', '')) - 5;
            }
            chip.style.top = topChipMove + 'px';

            // start store chip position move
            const objStoreChipPosiMove = {
                chipVal: chipVal,
                leftChipMove: leftChipMove,
                topChipMove: Number(topChipMove),
                zIndex: zIndexChip
            };
            // end store chip position move

            this.dataStoreBetting(typeBet, objStoreChipPosiMove);

            this.preventTimeoutRemove();
        }, 0);
        // end move effect chip
    }


    dataStoreBetting(typeBetChoose, objStoreChipPosiMove) {
        if (this.storeDataBetting.length <= 0) { // constructor store data betting
            this.dataTypeBet.itemBetting = typeBetChoose;
            this.dataTypeBet.totalMoney += Number(objStoreChipPosiMove.chipVal);
            this.dataTypeBet.chips.push(objStoreChipPosiMove);
            this.storeDataBetting.push(this.dataTypeBet);
        } else { // update data betting
            let countCheckExist = 0;
            this.storeDataBetting = this.storeDataBetting.map((item, idx) => {
                if (item['itemBetting'] === typeBetChoose) { // exist
                    const getMaxBetTypeBet = this.modelGame.find(itemMaxBet => itemMaxBet['typebet'] === item['itemBetting']);
                    if (item['totalMoney'] <= getMaxBetTypeBet['maxbet']) {
                        item['totalMoney'] += Number(objStoreChipPosiMove.chipVal);
                        item.chips.push(objStoreChipPosiMove);
                    }
                } else { // not exist
                    countCheckExist += 1;
                }
                return item;
            });

            // constructor store new data betting
            if (countCheckExist === this.storeDataBetting.length) {
                this.dataTypeBet = new DATA_ITEM_BETTING();
                this.dataTypeBet.itemBetting = typeBetChoose;
                this.dataTypeBet.totalMoney += Number(objStoreChipPosiMove.chipVal);
                this.dataTypeBet.chips.push(objStoreChipPosiMove);
                this.storeDataBetting.push(this.dataTypeBet);
            }
        }
        // this.totalMoneyShow = this.storeDataBetting.reduce((accumulator, currentValue) => { return accumulator + currentValue['totalMoney']; }, 0) * 1000;
        this.totalMoneyShow = this.storeDataBetting.reduce((accumulator, currentValue) => { return accumulator + currentValue['totalMoney']; }, 0);
    }

    updateMoneyGroupChips(typeBet) {
        const elTypeBet = this.pageDome.querySelector(`[data-bet="${typeBet}"]`);
        const elChipEmbed = elTypeBet.querySelectorAll('.chipEmbed');
        const elChipShowMoney = elChipEmbed[this.maxGroupChip - 1];
        // elChipShowMoney.querySelector('.numchip').innerHTML = this.typeBetChipsVal(typeBet).toString();
        if (this.typeBetChipsVal(typeBet) > 1000) {
            elChipShowMoney.querySelector('.numchip').innerHTML = (this.typeBetChipsVal(typeBet) / 1000).toString() + 'K';
        } else
            elChipShowMoney.querySelector('.numchip').innerHTML = this.cs.numberWithCommas(this.typeBetChipsVal(typeBet));
    }

    typeBetChipsVal(typeBet) {
        const elTypeBet = this.pageDome.querySelector(`[data-bet="${typeBet}"]`);
        const elChipEmbed = elTypeBet.querySelectorAll('.chipEmbed');
        let totalMoney = 0;
        for (let i = 0; i < elChipEmbed.length; i++) {
            const item = elChipEmbed[i];
            const getChipVal = item['dataset'].chipval;
            totalMoney += Number(getChipVal);
        }
        return totalMoney;
    }

    getPositionXYEl(el) {
        const elIonContent = this.pageDome.querySelector('ion-content.content');
        const getBoundingIonContent = elIonContent.getBoundingClientRect();
        const elScrollContent = this.pageDome.querySelector('.scroll-content');
        const getElScrollContentTop = Number(elScrollContent['style'].marginTop.replace(/px/g, ''));
        let getRectEl = el.getBoundingClientRect();
        return { x: getRectEl.left, y: getRectEl.top - getElScrollContentTop - getBoundingIonContent['top'], w: getRectEl.width, h: getRectEl.height };
    }

    chipSelect(chipVal) {
        // start update status chip
        this.objChips = this.objChips.map((item, idx) => {
            item['status'] = 0;
            if (item['chipVal'] === chipVal) {
                item['status'] = 1;
            }
            return item;
        });
        // end update status chip
    }

    preventTimeoutAdd() {
        let elOverlayBG = document.createElement('span');
        elOverlayBG.classList.add('bgoverlay');
        this.pageDome.appendChild(elOverlayBG);
        elOverlayBG.addEventListener('contextmenu', e => e.preventDefault());
    }

    preventTimeoutRemove() {
        this.pageDome.querySelector('.bgoverlay').remove();
    }

    guideGame() {
        let title = this.translate.instant('GAME_GUIDE_TITLE');
        let message = `
        <ul>
        <li>${this.translate.instant('BAU_CUA_GUIDE_STEP_1')}</li>
        <li>${this.translate.instant('BAU_CUA_GUIDE_STEP_2')}</li>
        <li>${this.translate.instant('BAU_CUA_GUIDE_STEP_3')}</li>
        <li>${this.translate.instant('BAU_CUA_GUIDE_STEP_4')}</li>
        </ul>
        <div class="example">
        <p class="exam"><strong>${this.translate.instant('EXAMPLE')}</strong>: ${this.translate.instant('EXAMPLE_RESULT')}</p>
        <p>- ${this.translate.instant('EXAMPLE_WIN_GA')}</p>
        <p>- ${this.translate.instant('EXAMPLE_WIN_TOM')}</p>
        <p>- ${this.translate.instant('EXAMPLE_WIN_TOM_GA')}</p>
        </div>`;
        let alertCmp = this.alertCtrl.create({
            title: title,
            cssClass: 'wrapperAlertBauCua',
            message: message,
            buttons: [
                {
                    text: this.translate.instant('OK')
                }
            ]
        });
        alertCmp.present();
    }

    showHistory() {
        this.app.getRootNav().push(BauCuaHistoryPage, {
            gameID: this.gameID
        });
    }

    reBet() {
        if (this.storeDataReBet.length <= 0) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: this.translate.instant('NO_PREVIOUS_BET')
            });
            return false;
        }

        const __this = this;

        // start remove all chips added before
        this.storeDataBetting.forEach(itemStore => {
            const elDataBet = this.pageDome.querySelector(`[data-bet=${itemStore.itemBetting}]`);
            const elsChipEmbed = elDataBet.querySelectorAll('.chipEmbed');
            this.removeAllEls(elsChipEmbed);
        });
        // end remove all chips added before

        this.storeDataBetting = this.storeDataReBet;

        // this.totalMoneyShow = this.storeDataBetting.reduce((accumulator, currentValue) => { return accumulator + currentValue['totalMoney']; }, 0) * 1000;
        this.totalMoneyShow = this.storeDataBetting.reduce((accumulator, currentValue) => { return accumulator + currentValue['totalMoney']; }, 0);
        this.storeDataReBet.forEach(itemsChipUI => {
            const chipUIData = itemsChipUI.chips;
            const elDataBet = this.pageDome.querySelector(`[data-bet=${itemsChipUI.itemBetting}]`);
            const elsChipEmbed = elDataBet.querySelectorAll('.chipEmbed');
            this.removeAllEls(elsChipEmbed);
            chipUIData.forEach((itemChipUI, idx) => {
                if (idx + 1 <= this.maxGroupChip) {
                    this.renderChipReBetting(itemsChipUI.itemBetting, itemChipUI, false);
                } else { // group chip value
                    this.renderChipReBetting(itemsChipUI.itemBetting, itemChipUI, true);
                }
            });
        });
    }

    renderChipReBetting(typeBet, dataChipUI, flagGroupChipVal) {
        const elTypeBetting = this.pageDome.querySelector(`[data-bet=${typeBet}]`);
        const chip = document.createElement('span');
        chip.style.position = "absolute";
        chip.setAttribute('data-chipval', dataChipUI.chipVal);
        chip.style.left = dataChipUI.leftChipMove + 'px';
        chip.style.top = dataChipUI.topChipMove + 'px';
        chip.style.zIndex = dataChipUI.zIndex;
        chip.setAttribute('href', 'javascript:void(0);');
        chip.classList.add('chip', 'chipEmbed');
        chip.innerHTML = `<span class="iconBauCua item chip-${dataChipUI.chipVal}"><span class="light-around iconBauCua"></span></span><span class="numchip">${dataChipUI.chipVal}</span>`;
        elTypeBetting.appendChild(chip);
        if (flagGroupChipVal) {
            chip.classList.add('chipEmbedHideGroup');
            this.updateMoneyGroupChips(typeBet);
        }
    }

    clearBet() {
        // const elsTypeBet = this.pageDome.querySelectorAll('[data-bet]');
        // for (let i = 0; i < elsTypeBet.length; i++) {
        //     const item = elsTypeBet[i];
        //     const elsChipEmbed = item.querySelectorAll('.chipEmbed');
        //     for (let i = 0; i < elsChipEmbed.length; i++) {
        //         elsChipEmbed[i].remove();
        //     }
        // }
        this.cancelbet();
        // this.cleanBetting();
    }

    plateAction(event) {
        const paramsBetting = new DATA_SUBMIT_BETTING();
        paramsBetting.gameid = this.gameID;
        this.storeDataBetting.forEach(item => {
            // paramsBetting.money += item['totalMoney'] * 1000;
            // paramsBetting.betdata[item['itemBetting']] = item['totalMoney'] * 1000;
            paramsBetting.money += item['totalMoney'];
            paramsBetting.betdata[item['itemBetting']] = item['totalMoney'];
        });
        if (paramsBetting.money > Number(this.storeBalance.replace(/[,]/g, ''))) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: this.translate.instant('INSUFFICIENT_BALANCE')
            });
            return;
        }

        const targetEl = this.getExaclyEl(event.target, 'plate');
        if (targetEl.classList.contains('openPlate')) {
            if (this.storeDataBetting.length <= 0) {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: this.translate.instant('PLEASE_BET')
                });
                return false;
            }
            this.preventTimeoutAdd();
            targetEl.classList.remove('openPlate');

            // timeout close plate: transition: all .2s ease-in-out; => 200
            const timeClosePlate = 150;
            setTimeout(() => {
                if (this.isMuted) this.objAudioPlay.play();
                const elPlateWrap = this.pageDome.querySelector('#plate');
                elPlateWrap.classList.add('xocPlate');
                // timeout finish xoc: animation: xocAction .5s cubic-bezier(0.55, 0.055, 0.675, 0.19); => 500
                const timeFinishXoc = 500;
                setTimeout(() => {
                    elPlateWrap.classList.remove('xocPlate');
                    targetEl.classList.add('statusOpenPlate');

                    //remove dice to can't see
                    const elWrapDice = this.pageDome.querySelector('#items-dice');
                    //elWrapDice.innerHTML = 'Chưa có kết quả!';
                    elWrapDice.innerHTML = '';
                    setTimeout(() => {
                        this.apiSubmitBetting(paramsBetting);
                    }, 500);
                }, timeFinishXoc + 200);
            }, timeClosePlate + 20);
        } else if (targetEl.classList.contains('statusOpenPlate')) {

        }
    }

    apiSubmitBetting(paramsBetting) {
        const elPlateUp = this.pageDome.querySelector('#plateup');
        this.loading(false, elPlateUp);
        this.bcService.bettingBC1s(paramsBetting, null).then(data => {
            this.loading(true, elPlateUp);
            if (data['msg'] === '') {
                this.storeDataReBet = this.storeDataBetting;
                const getResult = JSON.parse(data['betresult']);
                if (getResult['success'] === 1) { // is success
                    this.pageDome.querySelector('.moneyStatusBet').innerHTML = `-${this.cs.numberWithCommas(paramsBetting.money)}`;
                    this.pageDome.querySelector('#effectMoneyBet').classList.add('lossMoney', 'showMoneyEffectBet');
                    // timeout finish effect loss money: animation: effectMoneyStatusLoss 1s  ease-out; => 1000
                    const timeoutEffectMoneyLoss = 1000;
                    setTimeout(() => {
                        if (this.isMuted) this.objAudioOpen.play();
                        const dataResult = getResult['data'];
                        elPlateUp.classList.remove('statusOpenPlate');
                        elPlateUp.classList.add('openPlate');
                        this.randerPositionDice(dataResult['result']);
                        this.effectOpenWin(dataResult);
                    }, timeoutEffectMoneyLoss + 20);
                } else {
                    this.preventTimeoutRemove();
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data['msg']
                    });
                }
            } else {
                this.preventTimeoutRemove();
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data['msg']
                });
            }
        }).catch(error => {
            console.log(error);
            this.preventTimeoutRemove();
        });
    }

    /**
     * @param dataResult =
     * {
     *      balance: string, => 9809800
     *      betId: string, => B190607195339100069
     *      betTime: string, => 2019-06-07 19:53:39
     *      betcontent: string, => flag=baucua1sBet&gameid=92&money=10000&betdata[ga]=5000&betdata[tom]=5000
     *      codes: string, => [ga]Bet:5,000&&[tom]Bet:5,000,Prize:9,900&&
     *      details: array, => ["", "cua", "ca", "bau"]
     *      orderStatus: number, => 3
     *      prize: string, => 2100
     *      result: string => 4|5|2
     * }
     */
    effectOpenWin(dataResult) {
        const result = dataResult['result'].split('|');

        // this.storeBalance = this.common.numberWithCommas(dataResult['balance']);

        result.forEach(typeBetKey => {
            const getModelGameItem = this.modelGame.find(model => model['order'] === Number(typeBetKey));
            const elTypeBet = this.pageDome.querySelector(`[data-bet=${getModelGameItem['typebet']}]`);
            elTypeBet.classList.add('effectOpenWin');
        });

        // start check effect result > 2
        let storeCountDupliItem = { item: null, count: 0 };
        this.modelGame.forEach(model => {
            let countDupliItem = 0;
            result.forEach(typeBetKey => {
                if (model['order'] === Number(typeBetKey)) {
                    countDupliItem += 1;
                }
            });
            if (countDupliItem > storeCountDupliItem.count) {
                storeCountDupliItem = { item: model['typebet'], count: countDupliItem };
            }
        });
        if (storeCountDupliItem.count > 1) {
            const elTypeBetEffectNum = this.pageDome.querySelector(`[data-bet=${storeCountDupliItem.item}] .typebet`);
            const elNum = document.createElement('div');
            elNum.classList.add('effectNumWinMore');
            elNum.innerHTML = `<span>${storeCountDupliItem.count.toString()}</span>`;
            elTypeBetEffectNum.appendChild(elNum);
        }
        // end check effect result > 2

        setTimeout(() => {
            const elsTypeBet = this.pageDome.querySelectorAll('[data-bet]');
            this.removeClassesAllEls(elsTypeBet, 'effectOpenWin');

            if (Number(dataResult['prize']) > 0) {
                this.pageDome.querySelector('.moneyStatusBet').innerHTML = `+${this.cs.numberWithCommas(dataResult['prize'])}`;
                this.pageDome.querySelector('#effectMoneyBet').classList.add('winMoney', 'showMoneyEffectBet');
                // timeout finish effect: -webkit-animation: effectMoneyStatusWin 1.5s ease-out; => 1500
                const timeoutEffectMoneyWin = 1500;
                setTimeout(() => {
                    this.pageDome.querySelector('#effectMoneyBet').classList.remove('lossMoney', 'winMoney', 'showMoneyEffectBet');
                }, timeoutEffectMoneyWin + 20);
            } else {
                this.pageDome.querySelector('#effectMoneyBet').classList.remove('lossMoney', 'showMoneyEffectBet');
            }
            //hani
            this.apiGetBalance();

            this.cleanBetting();
            this.preventTimeoutRemove();

            const elNumEffect = this.pageDome.querySelector('.effectNumWinMore');
            if (elNumEffect) elNumEffect.remove();
        }, 2500);
    }

    cleanBetting() {
        this.storeDataBetting.forEach(itemStore => {
            const elDataBet = this.pageDome.querySelector(`[data-bet=${itemStore.itemBetting}]`);
            const elsChipEmbed = elDataBet.querySelectorAll('.chipEmbed');
            this.removeAllEls(elsChipEmbed);
        });
        this.storeDataBetting = [];
        this.totalMoneyShow = 0;
        this.dataTypeBet = new DATA_ITEM_BETTING();
    }

    ngOnInit() {
        this.apiInitBauCua();
        this.apiGetBalance();
    }

    ngAfterViewInit() {
        this.slides.ionSlideTransitionEnd.subscribe(() => this.slideTransitionEnd());
    }

    ngOnDestroy() { }

    dismissPage() {
        let tabsRoot = this.app.getRootNav();
        tabsRoot.pop();
    }

    toggleSound() {
        this.isMuted = !this.isMuted;
    }

    isEmptyObject(obj) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    getExaclyEl(el, clsEl) {
        let targetEl = null;
        if (el.classList.contains(clsEl)) {
            targetEl = el;
        } else {
            targetEl = el.closest('.' + clsEl);
        }
        return targetEl;
    }

    // numberWithCommas(x) {
    //     const num = Number(x).toFixed(0);
    //     return num.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // }

    loading(flagRemove, el) {
        if (flagRemove && el) {
            const getElLoading = el.querySelector('.lds-spinner');
            getElLoading.remove();
            return;
        }
        const elLoading = document.createElement('div');
        elLoading.classList.add('lds-spinner');
        elLoading.innerHTML = '<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>';
        el.appendChild(elLoading);
    }

    removeClassesAllEls(els, cls) {
        for (let i = 0; i < els.length; i++) {
            els[i].classList.remove(cls);
        }
    }

    removeAllEls(els) {
        for (let i = 0; i < els.length; i++) {
            els[i].remove();
        }
    }

    cancelbet() {
        ;
        this.totalMoneyShow = 0;

        const listChip = Array.from(document.querySelectorAll('.chipEmbed'));

        listChip.forEach(element => {
            element.classList.add('hideEffect');
        });
        setTimeout(() => {
            this.cleanBetting();
        }, 1000);
    }
}

function DATA_SUBMIT_BETTING() {
    this.flag = 'baucua1sBet';
    this.gameid = 92;
    this.money = 0;
    this.betdata = {};
}

function DATA_ITEM_BETTING() {
    this.totalMoney = 0;
    this.itemBetting = '';
    this.chips = [];
}




// WEBPACK FOOTER //
// ./src/pages/baucua1giay/baucua1giaypage.ts